export { useK8sModel } from '@console/dynamic-plugin-sdk/src/utils/k8s/hooks';
